import Query from "react-apollo/Query";
import React from "react";
import {GET_CURRENT_USER} from "../queries";
import { Redirect } from "react-router-dom";

export const withAuth = conditionFunc => Component => props => (
    <Query query={GET_CURRENT_USER}>
        {({data, loading}) => {
            if (loading) return null;
            let curUrl = window.location.href;

            if (curUrl.indexOf('/r/') > 0 ) {
                let newUrl = `/r/${curUrl.substr(curUrl.indexOf('/r/')+3)}`;
                console.log(newUrl);
                return conditionFunc(data) ? (
                    <Component {...props}/>
                ): (
                    <Redirect to={newUrl}/>
                );
            }

            if (curUrl.indexOf('/token/') > 0) {
                let newUrl = `/token/${curUrl.substr(curUrl.indexOf('/token/') + 7)}`;
                console.log(newUrl);
                let loginToken = `${curUrl.substr(curUrl.indexOf('/token/') + 7)}`;
                localStorage.setItem('token', loginToken);
                localStorage.setItem('tokenDefault', loginToken);
                sessionStorage.setItem('SessionTime', new Date());
                sessionStorage.setItem('DefaultToken', loginToken);
                window.open(process.env.SITE_ADDRESS, '_top');
                return conditionFunc(data) ? (
                    <Component {...props} />
                ) : (
                        <Redirect to={newUrl} />
                    );
            }

            let logkey = '';
            if (curUrl.split('?')[1]) {
                logkey = curUrl.split('?')[1];
            }            
            let redStr = `/noauth/${logkey}`;
            //console.log('data',data);
            return conditionFunc(data) ? (
                <Component {...props}/>
            ): (
                <Redirect to={redStr}/>
            );
        }}

    </Query>
);